import ColorThief from 'colorthief';
import { useEffect, useState } from 'react';

interface IUseGetAverageColorByImage {
  image?: HTMLImageElement;
  imageStatus: 'loaded' | 'loading' | 'failed';
  shouldSkipEmptySrc?: boolean;
}

export const useGetAverageColorByImageSrc = ({
  image,
  imageStatus,
  shouldSkipEmptySrc,
}: IUseGetAverageColorByImage) => {
  const [averageColor, setAverageColor] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (image?.src) {
      const colorThief = new ColorThief();

      if (imageStatus === 'loaded') {
        try {
          const colors = colorThief.getColor(image);
          setAverageColor(`rgb(${colors[0]}, ${colors[1]}, ${colors[2]})`);
        } catch (error) {
          console.error(error);
          setAverageColor('rgba(0, 0, 0, 0.8)');
        }
      }
    } else if (shouldSkipEmptySrc) {
      setAverageColor(undefined);
    }
  }, [image, shouldSkipEmptySrc, image?.src, imageStatus]);

  return averageColor;
};
